import { portalCustomizationZodSchema } from "@redotech/redo-model/customer-portal/portal-customization";
import * as z from "zod/v4";

export const getPortalCustomization = {
  name: "getPortalCustomization" as const,
  input: z.object({}),
  output: z.object({ customization: portalCustomizationZodSchema.nullable() }),
};

export {
  portalCustomizationZodSchema,
  type PortalCustomization,
} from "@redotech/redo-model/customer-portal/portal-customization";
